/**
 * The "mine" tag pill on a `WorkshopList` card.
 *
 * Independent of the ring (`WorkshopListItem`'s box-shadow) — a teacher's own
 * list wants the ring on every row and the tag on none; a terse row wants
 * neither. The label is the viewer's part on the crew (Teaching, Assisting,
 * Training) when the server sends it, else "Yours".
 *
 * Both colours flip with the theme: the pill's fill is a deep leaf green in
 * light mode and a pale one in dark, so its text cannot be a fixed white.
 */
import { CANCELLED_COLOR } from './cancelled-workshops';
import { DISABLED_COLOR } from './disabled-workshops';

export interface WorkshopListTagProps {
  show: boolean;
  label: string | null;
  /** Red, for a cancelled workshop (BON-624). White on the red reads in both themes. */
  danger?: boolean;
  /** Blue, for a workshop whose sales are disabled. */
  info?: boolean;
}

function tagColors(danger: boolean, info: boolean): { background: string; color: string } {
  if (danger) return { background: CANCELLED_COLOR, color: '#fff' };
  if (info) return { background: DISABLED_COLOR, color: 'var(--nb-surface)' };
  return { background: 'var(--nb-dark-leaf)', color: 'var(--nb-on-dark-leaf)' };
}

export function WorkshopListTag({
  show,
  label,
  danger = false,
  info = false,
}: WorkshopListTagProps) {
  if (!show || !label) return null;
  return (
    <span
      style={{
        position: 'absolute',
        top: -8,
        right: 12,
        fontSize: 9.5,
        fontWeight: 800,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        ...tagColors(danger, info),
        borderRadius: 999,
        padding: '2px 8px',
      }}
    >
      {label}
    </span>
  );
}
